import { z } from "zod";

export const fileUploadAttributeValueRequestSchema = z.object({
  attributeId: z.number().int(),
  value: z.string().min(1, "Value is required"),
});

export const fileUploadRequestSchema = z.object({
  fileName: z.string().min(1, "FileName is required"),
  contentType: z.string().nullable().optional(),
  categoryId: z.number().int(),
  attributeValues: z
    .array(fileUploadAttributeValueRequestSchema)
    .min(1, "At least one attribute value is required"),
  tagIds: z.array(z.number().int()).optional(),
});

export const updateFileAttributesRequestSchema = z.object({
  attributeValues: z
    .array(fileUploadAttributeValueRequestSchema)
    .min(1, "At least one attribute value is required"),
});

export const initiateFileUploadResponseSchema = z.object({
  message: z.string(),
  fileId: z.string(),
  fileName: z.string(),
  uploadUrl: z.string(),
});

export const bulkUpdateAttributesRequestSchema = z.object({
  categoryId: z.number().int(),
  fileIds: z.array(z.string()).min(1, "At least one file ID is required"),
  attributeValues: z
    .array(fileUploadAttributeValueRequestSchema)
    .min(1, "At least one attribute value is required"),
});

export const bulkAddTagsRequestSchema = z.object({
  fileIds: z.array(z.string()).min(1, "At least one file ID is required"),
  tagIds: z.array(z.number().int()).min(1, "At least one tag ID is required"),
});
